export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M18 20.75H6v-1.5h12v1.5ZM17.5 18h-2.14l-1.15-3.25H9.697L8.5 18h-2L11 6h2l4.5 12Zm-7.25-4.75h3.43L12 8.5l-1.75 4.75Z"/>
</svg>
`;
